import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { ToastMessageOptions, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { TransactionsService } from '../../_services/transactions.service';

@Component({
    selector: 'app-transaction-upload-excel',
    templateUrl: './transaction-upload-excel.component.html',
    styleUrls: ['./transaction-upload-excel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TransactionUploadExcelComponent {

  @ViewChild('fileUploader') fileUploader: FileUpload | undefined;

  public file: any;
  public messagesError: ToastMessageOptions[] = [];

  constructor(
    private config: DynamicDialogConfig,
    private transactionsService: TransactionsService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService) { }

  async onFileSelect(event: any) {
    this.file = event.currentFiles[0];
  }

  async importExcel() {
    let response = await firstValueFrom(this.transactionsService.uploadExcel(this.config.data.transactionId as string, this.file));

    if (!response.success) {
      this.messagesError = response.messages;
      this.file = null;
      this.fileUploader?.clear();
      return;
    }

    this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Fichero importado correctamente." });
    //las advertencias (totales que no cuadran) se muestran al cerrar, las líneas ya se han importado
    this.dynamicDialogRef.close(response.messages);
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  downloadTemplate() {
    this.transactionsService.downloadExcelTemplate();
  }

}
